/* eslint-disable import/prefer-default-export */
import { getRequest } from '../../utils/requests';
import { GET_PREFERENCE } from './Types';

export const getAllPreferences = () => async (dispatch) => {
    const response = await getRequest('/v1/vendor-dashboard/preferences');
    console.log(response);
    dispatch({
        type: GET_PREFERENCE,
        payload: response.data,
    });
};
